










































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import GuestReservationHistoryTableMobileTile from "./GuestReservationHistoryTableMobileTile.vue";
import ScrollLoader from "@/components/misc/ScrollLoader.vue";
import MobileFilterModal from "@/components/misc/MobileFilterModal.vue";
import { ListModel } from "@/shared/models/listModel";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import GuestReservationHistory from "@/shared/models/guestReservationHistory";

@Component({
  components: {
    GuestReservationHistoryTableMobileTile,
    MobileFilterModal,
    ScrollLoader,
  },
})

export default class GuestReservationHistoryTableMobile extends Vue {
  @PropSync("open", { default: false }) isOpen?: boolean;
  @Prop() customerId?: number;

  sortOrder = "desc";

  filters = {
        arrivalOrDepartureDate: "",
        accomodationUnitName: "",
        serviceTypeName: "",
        reservationId: ""
    };

  updateFilter(filters: any) {
    this.filters.reservationId = filters.reservationId;
    this.filters.arrivalOrDepartureDate = filters.arrivalOrDepartureDate;
    this.filters.accomodationUnitName = filters.accomodationUnitName;
    this.filters.serviceTypeName = filters.serviceTypeName;
      
    this.getReservations();
  }

    @Watch("open")
    async openChanged(fresh: boolean, old: boolean) {
        if(fresh && !old && this.customerId) {
            await this.getReservations();
        }
    }

    @Watch("sortOrder")
    async sortOrderChanged(fresh: string)
    {
        if(fresh === "asc")
        {
            this.options.sortAsc[0] = true;
        }
        if(fresh === "desc")
        {
            this.options.sortAsc[0] = false;
        }
        await this.getReservations();
    }

  reservations: ListModel<GuestReservationHistory> = {
    count: 0,
    result: [],
  };
  numberOfItems = 25;

  loading = false;
  done = false;

  async getReservations(): Promise<ListModel<GuestReservationHistory>> {
    this.loading = true;
    return Vue.axios.get<ListModel<GuestReservationHistory>>("/reservations/GetGuestReservationHistory", {
      params: this.queryParams(),
    })
    .then((res) => {
      if(res.data.result.length < this.numberOfItems)
      {
        this.done = true;
      }
      this.reservations = res.data;
      return this.reservations;
    })
    .finally(() => {
        this.loading = false;
    });
  }

  async getMoreReservations()
  {
    if(!this.loading && !this.done)
    {
      this.numberOfItems += 25;
      await this.getReservations();
    }
  }

  options = {
    sortBy: ["arrivalDate"],
    sortAsc: [false]
  }

  queryParams() {
    return {
        $skip: 0,
        $top: this.numberOfItems,
        $orderby: formatOrderbyArray(
            this.options.sortBy,
            this.options.sortAsc
        ),
        $count: true,
        ...this.filters,
        customerId: this.customerId
    }
  }

  scrollEl = null as HTMLElement | null;
  mounted() {
    if(this)
    {
      this.scrollEl = (this.$refs.unitsWrapper as HTMLElement);
    }
  }

  firstUpper(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  changeSortOrder()
  {
    if(this.sortOrder === "asc")
    {
      this.sortOrder = "desc";
    }
    else {
      this.sortOrder = "asc";
    }
  }

  scrollId: string | null = null;

  filterModalOpen = false;

  closeModal() {
    this.isOpen = false;
  }
}

